import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import type { MatchStatus } from "../types";

/**
 * EPIC-119 D4 (judge round 1 point 6): the operator's manual "Voltear cancha"
 * override. It is cleared on EVERY match status change (not only when the
 * display period changes), so a press made during Halftime or after the
 * second-half kickoff cannot leave the pitch inverted for the whole half.
 */
export function useManualFlipOverride(
  status: MatchStatus | undefined,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [override, setOverride] = useState(false);
  useEffect(() => {
    setOverride(false);
  }, [status]);
  return [override, setOverride];
}
